import React from "react";
import { XCircle, RefreshCcw, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./components/AuthLayout";
import { clearAuthFlow, clearAuthSession, getAuthUser } from "./components/authStore";
import AuthPopup from "./components/AuthPopup";

export default function ApprovalRejected() {
  const nav = useNavigate();
  const user = getAuthUser();

  const onLogout = () => {
    clearAuthFlow();
    clearAuthSession();
    nav("/admin/login", { replace: true });
  };

  return (
    <AuthLayout>
      <div className="mx-auto w-full max-w-[450px] rounded-[24px] border border-[#f6d8dd] bg-white p-6 text-center shadow-[0_20px_70px_rgba(216,106,120,0.12)] sm:p-8">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#fff1f3] text-[#d86a78]">
          <XCircle size={32} />
        </div>

        <h1 className="mt-5 text-[30px] font-bold tracking-wide text-[#d86a78]">
          APPROVAL REJECTED
        </h1>

        <p className="mt-3 text-[14px] leading-6 text-slate-500">
          Your onboarding request was rejected by admin.
        </p>

        <div className="mt-6 rounded-[16px] border border-[#f6d8dd] bg-[#fff8f9] px-4 py-4 text-left">
          <div className="text-[12px] font-semibold uppercase tracking-wide text-slate-500">
            Admin Note
          </div>
          <div className="mt-2 text-[14px] text-slate-700">
            {user?.approvalNote || "No note provided by admin."}
          </div>
        </div>

        <div className="mt-6 space-y-3">
          <button
            type="button"
            onClick={() => nav("/admin/onboarding", { replace: true })}
            className="inline-flex h-[44px] w-full items-center justify-center gap-2 rounded-[10px] bg-[#d86a78] text-[13px] font-semibold text-white hover:bg-[#c95b69]"
          >
            <RefreshCcw size={16} />
            Onboarding Again
          </button>

          <button
            type="button"
            onClick={onLogout}
            className="inline-flex h-[44px] w-full items-center justify-center gap-2 rounded-[10px] border border-[#f2c6cc] text-[13px] font-semibold text-slate-600 hover:bg-slate-50"
          >
            <LogOut size={16} />
            Logout
          </button>
        </div>
      </div>
    </AuthLayout>
  );
}